<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_View') + this.tabNumberTitle + $t('CargoMsg.Cargo_Config')"
    width="1000px"
    :close-on-click-modal="false"
    append-to-body
    class="app-main-inner"
    @close="closeHandler()"
  >
    <div class="app-main-inner-row" style="padding-bottom: 20px;">
      <el-form label-width="70px" label-position="left" style="width: 100%">
        <el-row :gutter="10">
          <el-col v-if="isBusinessTypeTab" :span="6">
            <el-form-item :label="$t('CargoMsg.Cargo_BusinessType')">
              <el-select v-model="filter.businessTypes" filterable multiple :placeholder="$t('Message.PleaseSelect')" class="custom-select-width">
                <el-option
                  v-for="item in businessTypeList"
                  :key="item.code"
                  :label="item.chineseName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('CargoMsg.Cargo_BranchCMP')">
              <cargo-advance-select
                :select-type="selectTypeNames.basic_data_Office_All"
                tag-name="code"
                callback-method-type="value"
                clearable
                filterable
                :multiple="true"
                :default-multiple-value="filter.officeIds"
                class="custom-select-width"
                @parentCallBack="value=>filter.officeIds=[...value]"
              />
            </el-form-item>
          </el-col>
          <el-col v-if="this.tabName === 'MblNo'" :span="6">
            <el-form-item :label="$t('SystemMaintenance.RuleName')">
              <el-input v-model="filter.ruleName" class="custom-select-width" clearable />
            </el-form-item>
          </el-col>
          <el-col v-if="this.tabName === 'MblNo'" :span="6">
            <el-form-item :label="$t('SystemMaintenance.DesignatedShippingLine')">
              <cargo-advance-select
                no="carrierId"
                clearable
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{companyLob:'seaExport',seaCmp:true,active:true}"
                callback-method-type="value"
                :multiple="true"
                :default-multiple-value="filter.carrierIds"
                class="custom-select-width"
                @parentCallBack="value=>filter.carrierIds=[...value]"
              />
            </el-form-item>
          </el-col>
          <el-col v-if="this.tabName === 'BillNo'" :span="6">
            <el-form-item :label="$t('SystemMaintenance.BillOfLadingType')">
              <el-select v-model="filter.billTypes" multiple>
                <el-option
                  v-for="(item,index) in SystemConstants.BILL_TYPE_SOURCE"
                  :key="index"
                  :label="item.chineseName"
                  :value="item.code"
                  class="custom-select-width"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-button type="primary" @click="toQuery">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
            <el-button type="primary" @click="reset">{{ $t('CargoMsg.Cargo_Empty') }}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <cargo-ag-grid
      :grid-params.sync="girdParams"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      :enable-col-resize="true"
      style="width:100%;height:300px"
      @gridReady="params=>{gridApi=params.api}"
    />
  </el-dialog>
</template>

<script>

import {
  BILL_PAYMENT_NO_CONFIGS,
  BILLING_GROUP_INTERNAL_NO_CONFIGS,
  BILLING_GROUP_NO_CONFIGS,
  BILLING_INTERNAL_NO_CONFIGS,
  BILLING_NO_CONFIGS,
  HBL_NO_CONFIGS,
  JOB_NO_CONFIGS,
  MBL_BILL_NO_CONFIGS,
  MBL_NO_CONFIGS,
  WAREHOUSE_NO_CONFIGS, WRITE_OFF_NO_CONFIGS
} from '@/class/cargo/model/parameters/SystemConstants'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import { basicCacheKeys as selectTypeNames } from '@/utils/cacheConfig'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoOwnedBranchSelect from '@/components/Cargo/Common/CargoOwnedBranchSelect.vue'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect.vue'
import CustomLableUtils from '@/utils/CustomLabelUtils'

export default {
  name: 'NumberConfigSearchDialog',
  components: { cargoCompanySelect, CargoOwnedBranchSelect, CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    tabNumberTitle: { type: String, default: '' },
    tabName: { type: String, default: '' }
  },
  data() {
    return {
      loading: null,
      innerVisible: false,
      filter: {
        carrierIds: [],
        billTypes: [],
        ruleName: '',
        businessTypes: [],
        originBusinessTypeList: [],
        officeIds: []
      },
      businessTypeList: [],
      girdParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: event => { this.selectedRow = event.data }
      },
      columnDefs: [],
      rowData: [],
      selectedRow: null,
      gridApi: null
    }
  },
  computed: {
    selectTypeNames() {
      return selectTypeNames
    },
    isBusinessTypeTab() {
      const validTabs = ['JobNo', 'MblNo', 'HblNo', 'WareHouseNo', 'BillNo']
      return validTabs.includes(this.tabName)
    },
    SystemConstants() {
      return SystemConstants
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        this.innerVisible = newVal
      },
      immediate: true
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.filter.businessTypes = []
        this.filter.officeIds = []
        this.rowData = []
        this.selectedRow = null
      }
    }
  },
  created() {
    this.initData()
  },
  methods: {
    async onShow(rowData) {
      this.rowData = [...rowData]
    },
    initData() {
      console.log('initData', this.tabName)
      if (['JobNo', 'HblNo', 'WareHouseNo'].includes(this.tabName)) {
        if (this.tabName === 'JobNo') {
          this.filter.originBusinessTypeList = Array.from(JOB_NO_CONFIGS).map(item => item.code)
          this.businessTypeList = JOB_NO_CONFIGS
        }
        if (this.tabName === 'HblNo') {
          this.filter.originBusinessTypeList = Array.from(HBL_NO_CONFIGS).map(item => item.code)
          this.businessTypeList = HBL_NO_CONFIGS
        }
        if (this.tabName === 'WareHouseNo') {
          this.filter.originBusinessTypeList = Array.from(WAREHOUSE_NO_CONFIGS).map(item => item.code)
          this.businessTypeList = WAREHOUSE_NO_CONFIGS
        }
        this.columnDefs.push({
          headerName: this.$t('CargoMsg.Cargo_BusinessType'), field: 'businessTypeName', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.NumberConfigBusinessTypeLabelFunc(params.value, this.businessTypeList)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BranchCMP'),
          field: 'configOfficeId',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'code')
          }
        },
        {
          headerName: this.$t('SystemMaintenance.Expression'), field: 'configValue', width: 200
        }, {
          headerName: this.$t('SystemMaintenance.Example'), field: 'example', width: 200
        })
      }
      if (this.tabName === 'MblNo') {
        this.filter.originBusinessTypeList = Array.from(MBL_NO_CONFIGS).map(item => item.code)
        this.businessTypeList = MBL_NO_CONFIGS
        this.columnDefs.push({
          headerName: this.$t('CargoMsg.Cargo_BusinessType'), field: 'businessTypeName', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.NumberConfigBusinessTypeLabelFunc(params.value, SystemConstants.MBL_NO_CONFIGS)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BranchCMP'),
          field: 'configOfficeId',
          width: 100,
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'code')
          }
        },
        {
          headerName: this.$t('SystemMaintenance.Expression'), field: 'configValue', width: 200
        }, {
          headerName: this.$t('SystemMaintenance.Example'), field: 'example', width: 200
        }, {
          headerName: this.$t('SystemMaintenance.RuleName'), field: 'ruleName', width: 100
        }, {
          headerName: this.$t('SystemMaintenance.DesignatedShippingLine'), field: 'partnerId', width: 200,
          valueFormatter: params => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_5')
          }
        })
      }
      if (['BillingNo', 'BillPaymentNo', 'BillingInternalNo', 'BillingGroupInternalNo', 'BillingGroupNo', 'WriteOffNo'].includes(this.tabName)) {
        if (this.tabName === 'BillingNo') {
          this.filter.originBusinessTypeList = Array.from(BILLING_NO_CONFIGS).map(item => item.code)
          this.businessTypeList = BILLING_NO_CONFIGS
        }
        if (this.tabName === 'BillPaymentNo') {
          this.filter.originBusinessTypeList = Array.from(BILL_PAYMENT_NO_CONFIGS).map(item => item.code)
          this.businessTypeList = BILL_PAYMENT_NO_CONFIGS
        }
        if (this.tabName === 'BillingInternalNo') {
          this.filter.originBusinessTypeList = Array.from(BILLING_INTERNAL_NO_CONFIGS).map(item => item.code)
          this.businessTypeList = BILLING_INTERNAL_NO_CONFIGS
        }
        if (this.tabName === 'BillingGroupInternalNo') {
          this.filter.originBusinessTypeList = Array.from(BILLING_GROUP_INTERNAL_NO_CONFIGS).map(item => item.code)
          this.businessTypeList = BILLING_GROUP_INTERNAL_NO_CONFIGS
        }
        if (this.tabName === 'BillingGroupNo') {
          this.filter.originBusinessTypeList = Array.from(BILLING_GROUP_NO_CONFIGS).map(item => item.code)
          this.businessTypeList = BILLING_GROUP_NO_CONFIGS
        }
        if (this.tabName === 'WriteOffNo') {
          this.filter.originBusinessTypeList = Array.from(WRITE_OFF_NO_CONFIGS).map(item => item.code)
          this.businessTypeList = WRITE_OFF_NO_CONFIGS
        }
        this.columnDefs.push(
          {
            headerName: this.$t('CargoMsg.Cargo_BranchCMP'),
            field: 'configOfficeId',
            width: 100,
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'code')
            }
          },
          {
            headerName: this.$t('SystemMaintenance.Expression'), field: 'configValue', width: 200
          }, {
            headerName: this.$t('SystemMaintenance.Example'), field: 'example', width: 200
          }
        )
      }
      if (this.tabName === 'BillNo') {
        this.filter.originBusinessTypeList = Array.from(MBL_BILL_NO_CONFIGS).map(item => item.code)
        this.businessTypeList = MBL_BILL_NO_CONFIGS
        this.columnDefs.push({
          headerName: this.$t('CargoMsg.Cargo_BusinessType'), field: 'businessTypeName', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.NumberConfigBusinessTypeLabelFunc(params.value, SystemConstants.MBL_BILL_NO_CONFIGS)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BranchCMP'),
          field: 'configOfficeId',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'code')
          }
        },
        {
          headerName: this.$t('SystemMaintenance.Expression'), field: 'configValue', width: 200
        }, {
          headerName: this.$t('SystemMaintenance.Example'), field: 'example', width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_BLType'), field: 'businessTypeName', width: 100,
          cellRenderer: (params) => {
            return params.value && params.value.indexOf('MBL') > -1 ? this.$t('CargoMsg.Cargo_MasterBill') : this.$t('Message.SplittingBusiness')
          }
        })
      }
    },
    async toQuery() {
      this.$emit('query', this.filter)
    },
    reset() {
      this.filter.billTypes = []
      this.filter.carrierIds = []
      this.filter.ruleName = ''
      this.filter.officeIds = []
      this.filter.businessTypes = []
    },
    closeHandler() {
      this.innerVisible = false
      this.filter = {}
      this.businessTypeList = []
      this.$emit('update:visible', false) // 同步更新父组件的 visible 属性
    }
  }
}
</script>

<style scoped>/* 自定义类名样式 */
.custom-select-width {
  width: 150px; /* 固定宽度为 150px */
}
</style>
